// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GNjj","colBig":"styles_colBig__b2xV7","colSmall":"styles_colSmall__345gk"};